import { Grid } from "@mui/material";
import React, { useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import DeleteIcon from "../../icons/DeleteIcon";
import { checkLoggedIn, mergeClasses } from "../../utils";
import HeartCloseIcon from "../../icons/HeartCloseicon";
import { MoonLoader } from "react-spinners"; // For loading spinner
import BuyNowIcon from "../../icons/BuyNowIcon";
import { useLoginModal } from "../../Context/LoginModalContext";
import { toast } from "react-toastify";
import "./index.css";
//Product Grid................
const ProductCard = ({
  product,
  key,
  addToWishListProduct,
  addToCartProduct,
  addToCartBundleMain,
  handleClickOpen,
  carts,
  removeFromCart,
  decrementQuantity,
  incrementQuantity,
  className,
  w_list,
  ...props
}) => {
  const [loadingState, setLoadingState] = useState({
    buyNow: false,
    addToCart: false,
    increment: false,
    decrement: false,
  }); // Separate loading states

  const { badges } = product;
  const navigate = useNavigate();
  const { openLoginModal } = useLoginModal();
  const productImage = useMemo(() => product.proimg?.[0], [product.proimg]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [bundleQuantities, setBundleQuantities] = useState({});
  const [selectedBundle, setSelectedBundle] = useState(
    product?.pricebundle?.[0]
  );

  const inCart = useMemo(() => {
    return carts.find((cart) => cart.id === product?.id);
  }, [carts, product]);

  const inWishList = useMemo(() => {
    return w_list?.find((wish) => wish.id === product?.id);
  }, [w_list, product]);

  // Function to handle adding to cart
  const handleAddToCart = async () => {
    if (checkLoggedIn()) {
      setLoadingState({ ...loadingState, addToCart: true }); // Start loading
      await addToCartProduct(product); // Wait for the API call to complete
      setLoadingState({ ...loadingState, addToCart: false }); // Stop loading
    } else {
      setLoadingState({ ...loadingState, addToCart: true }); // Strat loading
      setTimeout(() => {
        addToCartProduct(product); // Adding Data in Redux
        setLoadingState({ ...loadingState, addToCart: false }); // Stop loading
      }, 1000);
    }
  }; 
  const handleAddToCartBundle = async (
    bundlePrice,
    bundleQty,
    productId,
    singleProduct
  ) => {
    if (checkLoggedIn()) {
      const selectedQty = 1;
      const finalPrice = Number(Number(bundlePrice) * bundleQty).toFixed(2);
      setLoadingState({ ...loadingState, addToCart: true });

      // console.log("Adding bundle to cart 1:", {
      //   bundlePrice,
      //   bundleQty,
      //   productId,
      //   selectedQty,
      //   finalPrice,
      //   singleProduct
      // });

      await addToCartBundleMain(
        bundlePrice,
        bundleQty,
        productId,
        selectedQty,
        finalPrice,
        singleProduct
      );

      setLoadingState({ ...loadingState, addToCart: false });
    } else {
      setLoadingState({ ...loadingState, addToCart: true });
      toast.error("Please login to add items to cart");
    }
  };

  // Function to handle incrementing quantity
  const handleIncrementQuantity = async () => {
    if (checkLoggedIn()) {
      setLoadingState({ ...loadingState, increment: true }); // Start loading
      await incrementQuantity(product.id); // Wait for the API call to complete
      setLoadingState({ ...loadingState, increment: false }); // Stop loading
    } else {
      setLoadingState({ ...loadingState, increment: true }); // Start loading
      setTimeout(() => {
        incrementQuantity(product.id);
        setLoadingState({ ...loadingState, increment: false }); // Stop loading
      }, 1000);
    }
  };

  // Function to handle decrementing quantity or removing from cart
  const handleDecrementQuantity = async () => {
    if (checkLoggedIn()) {
      setLoadingState({ ...loadingState, decrement: true }); // Start loading
      if (inCart.qty === 1) {
        await removeFromCart(product.id);
      } else {
        await decrementQuantity(product.id);
      }
      setLoadingState({ ...loadingState, decrement: false }); // Stop loading
    } else {
      setLoadingState({ ...loadingState, decrement: true }); // Start loading
      if (inCart.qty === 1) {
        setTimeout(() => {
          removeFromCart(product.id);
          setLoadingState({ ...loadingState, decrement: false }); // Stop loading
        }, 1000);
      } else {
        setTimeout(() => {
          decrementQuantity(product.id);
          setLoadingState({ ...loadingState, decrement: false }); // Stop loading
        }, 1000);
      }
    }
  };

  const handleClick = (event) => {
    event?.preventDefault();
    navigate(`/product-single/${product?.slug}`);
  };

  return (
    <div className={mergeClasses("product-card-wrapper", className)} key={key}>
      <div className="product-item">
        <div className="product-image">
          <img
            className="z-[-100] imag-one"
            src={productImage?.src}
            alt={productImage?.id}
            onClick={handleClick}
          />
          {/* <ul className="tag-wrap z-[-100] imag-three" onClick={handleClick}>
            {badges.length > 0 &&
              badges.map((badge, index) => {
                return (
                  <li className={`tag ${badge}`} key={badge + index}>
                    {badge}
                  </li>
                );
              })}
          </ul> */}
          {product?.is_price_bundle ? <ul
                    className="tag-wrap z-[-100] imag-three" onClick={handleClick}
                  >

<li className="tag bg-red-600 text-white font-semibold off-per">{(
                                        ((Number(
                                          product.pricebundle[0].price
                                        ) -
                                          Number(product.pricebundle[product?.pricebundle?.length - 1].price)) /
                                          Number(
                                            product.pricebundle[0].price
                                          )) *
                                        100
                                      ).toFixed(0)} % Off</li>
                  </ul> : <ul
                    className="tag-wrap z-[-100] imag-three"
                  >
                    {product.delPrice &&
                      Math.round(
                        ((product.delPrice - product.price) /
                          product.delPrice) *
                          100
                      ) > 0 && (
                        <li className="tag bg-red-600 text-white font-semibold off-per">
                          {Math.round(
                            ((product.delPrice - product.price) /
                              product.delPrice) *
                              100
                          )}
                          % OFF
                        </li>
                      )}
                  </ul>}

          <ul className="info-wrap">
            {inWishList ? (
              <li>
                <button
                  data-tooltip-id="wish-tooltip"
                  data-tooltip-content="Remove From Wishlist"
                  data-tooltip-place="left"
                  onClick={() => addToWishListProduct(product)}
                >
                  <HeartCloseIcon />
                </button>
                <Tooltip id="wish-tooltip" />
              </li>
            ) : (
              <li>
                <button
                  data-tooltip-id="wish-tooltip"
                  data-tooltip-content="Add to Wishlist"
                  data-tooltip-place="left"
                  onClick={() => addToWishListProduct(product)}
                >
                  <i className="icon-heart"></i>
                </button>
                <Tooltip id="wish-tooltip" />
              </li>
            )}

            <li data-bs-toggle="modal" data-bs-target="#modal-cart-view">
              <button
                data-tooltip-id="view-tooltip"
                data-tooltip-content="Quick View"
                data-tooltip-place="left"
                onClick={
                  handleClickOpen ? () => handleClickOpen(product) : () => {}
                }
              >
                <i className="icon-open-eye-1"></i>
              </button>
              <Tooltip id="view-tooltip" />
            </li>
          </ul>
        </div>
        <div className="product-info text-center">
          <div
            className="product-card-title w-full text-center"
            onClick={handleClick}
          >
            <h2
              data-tooltip-id="title-tooltip"
              data-tooltip-content={product?.title}
              data-tooltip-place="top"
            >
              <Link to={`/product-single/${product.slug}`}>
                {product.title}
              </Link>
              <Tooltip id="title-tooltip" />
            </h2>
          </div>

          <div className="product-card-footer">
            <div className="w-full mb-2" onClick={handleClick}>
              {/* <span className="present-price">${product?.price}</span>
              <del className="old-price">${product?.delPrice}</del> */}

              {product?.is_price_bundle ? (
                <span className="present-price">
                  $
                  {product?.pricebundle[product?.pricebundle.length - 1]?.price}{" "}
                  - ${product?.pricebundle[0]?.price}
                </span>
              ) : (
                <>
                  <span className="present-price">${product?.price}</span>
                  <del className="old-price">${product?.delPrice}</del>
                </>
              )}
            </div>
          </div>

          <div className="w-full" onClick={handleClick}>
            <h6>
              Category : {product?.category}{" "}
              {product?.is_price_bundle ? "(Bundle)" : ""}
            </h6>
          </div>
          <div className="w-full mb-2" onClick={handleClick}>
            <h6>Brand : {product?.brand}</h6>
          </div>

          {product?.is_price_bundle ? (
            <div className="relative inline-block w-full">
              <div
                className="border rounded bg-white cursor-pointer"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <div className="flex justify-between items-center p-2">
                  <span>
                    {selectedBundle?.qty} Tablet/s - US${" "}
                    {Number(
                      selectedBundle?.price * selectedBundle?.qty
                    ).toFixed(2)}
                  </span>
                  <i
                    className={`icon-chevron-down transition-transform ${
                      showDropdown ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </div>

              {showDropdown && (
                <ul className="absolute imag-two w-full bg-white border rounded shadow-md mt-1 max-h-60 overflow-y-auto">
                  {product?.pricebundle?.map((item, index) => {
                    const selectedQty = bundleQuantities[item._id] || 1;
                    const originalPrice =
                      product?.pricebundle?.[0]?.price * item.qty;
                    const finalPrice = item.price * item.qty;
                    const discount = (
                      ((product?.pricebundle?.[0]?.price - item.price) /
                        product?.pricebundle?.[0]?.price) *
                      100
                    ).toFixed(0);

                    return (
                      <li
                        key={item._id}
                        onClick={() => {
                          setSelectedBundle(item);
                          setShowDropdown(false);
                        }}
                        className="p-2 hover:bg-gray-100 cursor-pointer border-b last:border-b-0"
                      >
                        <div
                          className="flex justify-between items-center"
                          style={{
                            border: "2px solid #f0f0f0",
                            padding: "10px",
                            borderRadius: "8px",
                          }}
                        >
                          <span style={{ color: "black", fontWeight: "400" }}>
                            {item.qty} Tablet/s
                          </span>

                          <div className="text-right flex flex-col items-end">
                            <p
                              className="text-black font-bold"
                              style={{ marginTop: 10 }}
                            >
                              US$ {finalPrice.toFixed(2)}
                            </p>

                            {index !== 0 && (
                              <div className="flex gap-2 text-sm justify-end">
                                <p
                                  style={{
                                    fontSize: 12,
                                    color: "red",
                                    textDecoration: "line-through",
                                    marginTop: -18,
                                  }}
                                >
                                  US$ {originalPrice.toFixed(2)}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ) : (
            <></>
          )}

          <div className="mt-2 product-card-button-footer">
            {/* <div className="flex">
              <button
                className="buy-now-btn"
                data-tooltip-id="buy-now-button"
                data-tooltip-content="Buy Now"
                data-tooltip-place="top"
                onClick={async () => {
                  if (!checkLoggedIn()) {
                    setLoadingState({ ...loadingState, buyNow: true });
                    await addToCartProduct(product);
                    setLoadingState({ ...loadingState, buyNow: false });
                    navigate("/cart");
                  } else if (inCart) {
                    navigate("/cart");
                  } else {
                    setLoadingState({ ...loadingState, buyNow: true });
                    await addToCartProduct(product);
                    setLoadingState({ ...loadingState, buyNow: false });
                    navigate("/cart");
                  }
                }}
                disabled={
                  loadingState?.buyNow ||
                  loadingState?.addToCart ||
                  loadingState?.increment ||
                  loadingState?.decrement
                } // Disable all other buttons while loading
              >
                {loadingState?.buyNow ? (
                  <MoonLoader size={16} color="#fafafa" />
                ) : (
                  <BuyNowIcon />
                )}
                Buy Now
              </button>
            </div> */}
            <div className="flex items-center justify-between">
              <Link
                to={`/product-single/${product.slug}`}
                className="cart-btn-full-details"
              >
                View Details
              </Link>
            </div>
            {product?.is_price_bundle ? (
              <div>
                <button
                  className="cart-btn-full"
                  onClick={() =>
                    handleAddToCartBundle(
                      selectedBundle?.price,
                      selectedBundle?.qty,
                      product?._id,
                      product
                    )
                  }
                  disabled={
                    loadingState?.buyNow ||
                    loadingState?.addToCart ||
                    loadingState?.increment ||
                    loadingState?.decrement
                  } // Disable all other buttons while loading
                >
                  {loadingState?.addToCart ? (
                    <MoonLoader size={16} color="#fafafa" />
                  ) : (
                    <>
                      <i className="icon-cart" style={{ marginRight: 10 }}></i>{" "}
                      {/* Add to Cart */}
                    </>
                  )}
                </button>
              </div>
            ) : (
              <div>
                <button
                  className="cart-btn-full"
                  onClick={handleAddToCart}
                  disabled={
                    loadingState?.buyNow ||
                    loadingState?.addToCart ||
                    loadingState?.increment ||
                    loadingState?.decrement
                  } // Disable all other buttons while loading
                >
                  {loadingState?.addToCart ? (
                    <MoonLoader size={16} color="#fafafa" />
                  ) : (
                    <>
                      <i className="icon-cart" style={{ marginRight: 10 }}></i>{" "}
                      {/* Add to Cart */}
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
          <Tooltip id="buy-now-button" />
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
